import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {
	deleteMaintenance,
	fetchMaintenance,
	updateMaintenance,
} from "../../actions/maintenance";
import { DateTimeFormat } from "../../helpers/utils";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import MaintenanceForm from "../Forms/Maintenance";
import moment from "moment";

const MaintenancePage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [maintenanceId, setMaintenanceId] = useState(null);
	const { status, maintenance } = useSelector(
		(state) => state.fetchMaintenance,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateMaintenance,
	);
	const { maintenanceDeleted } = useSelector(
		(state) => state.deleteMaintenance,
	);

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	const handleEdit = () => {
		showModal();
		setMaintenanceId(maintenance.id);
		form.setFieldsValue({
			...maintenance,
			periodFrom: moment(maintenance.periodFrom).utcOffset("+08:00"),
			periodTo: moment(maintenance.periodTo).utcOffset("+08:00"),
		});
	};

	const handleDelete = () => {
		dispatch(deleteMaintenance(maintenance.id));
	};

	const handleSubmitForm = (values) => {
		if (maintenanceId) {
			dispatch(updateMaintenance(maintenanceId, values));
		}
		handleOk();
	};

	useEffect(() => {
		if (status === "IDLE") {
			dispatch(fetchMaintenance(id));
		}
	}, [status]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchMaintenance(id));
	}, [updateStatus]);

	useEffect(() => {
		if (maintenanceDeleted) {
			history.push("/maintenances");
		}
	}, [maintenanceDeleted]);

	return (
		<div id="maintenance-container">
			<div className="page-header">
				<h2 className="page-header-title">Maintenance Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/maintenances">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									{/* <div className="details-item">
										<label>Enabled</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{maintenance.enabled ? "Yes" : "No"}
										</div>
									</div> */}
									<div className="details-item">
										<label>Code</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{maintenance.code}
										</div>
									</div>
									<div className="details-item">
										<label>Period From</label>
										<div className="text">
											{DateTimeFormat(maintenance.periodFrom)}
										</div>
									</div>
									<div className="details-item">
										<label>Period To</label>
										<div className="text">
											{DateTimeFormat(maintenance.periodTo)}
										</div>
									</div>
									<div className="details-item">
										<label>Updated At</label>
										<div className="text">
											{DateTimeFormat(maintenance.updated_at)}
										</div>
									</div>
									<div className="details-item">
										<label>Created At</label>
										<div className="text">
											{DateTimeFormat(maintenance.created_at)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="add-category-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<MaintenanceForm
					form={form}
					maintenanceId={maintenanceId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
				/>
			</Modal>
		</div>
	);
};

export default MaintenancePage;
